// extracted by mini-css-extract-plugin
module.exports = {"head":"index_head_2xzEe","tabs":"index_tabs_3s9xM"};